"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _apolloBoost = _interopRequireWildcard(require("apollo-boost"));

exports.gql = _apolloBoost.gql;

var _jwt = require("@engaging-tech/jwt");

var Apollo =
/**
 * Initialises the Apollo Client. There is logic present within the constructor
 * to ensure that we only ever have *one* instance of the class running.
 */
function Apollo() {
  var _this = this;

  (0, _defineProperty2["default"])(this, "getLanguage", function () {
    return window && window.localStorage && window.localStorage.getItem("i18nextLng");
  });
  (0, _defineProperty2["default"])(this, "createClientWithToken", function (uri) {
    var token = (0, _jwt.getTokenString)();

    var language = _this.getLanguage();

    var headerObj = language ? {
      "content-language": language
    } : {};
    return new _apolloBoost["default"]({
      uri: uri,
      request: function request(operation) {
        return token ? operation.setContext({
          headers: (0, _extends2["default"])({}, headerObj, {
            Authorization: "JWT " + token
          })
        }) : operation.setContext({
          headers: headerObj
        });
      }
    });
  });
  (0, _defineProperty2["default"])(this, "query", function (_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        uri = _ref.uri,
        queryParams = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["uri"]);

    return _this.createClientWithToken(uri).query(queryParams);
  });
  (0, _defineProperty2["default"])(this, "mutate", function (_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        uri = _ref2.uri,
        mutationParams = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["uri"]);

    return _this.createClientWithToken(uri).mutate(mutationParams);
  });

  /* eslint-disable-next-line no-extra-boolean-cast */
  if (!!Apollo.instance) {
    return Apollo.instance;
  }

  return this;
};

var _default = Apollo;
exports["default"] = _default;